import React, { useRef, useState } from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import Text from '../../../../../global/text/text';
import { OpenIcon } from '../../../../../global/icons/icons';
import ChevronSVG from '../../../../../../images/svg/icons8-expand-arrow';
import classnames from 'classnames';
import { Popover } from '../../../../../global/popover/popover';

interface RegistrationFormHeaderProps {
    openRegistrationFormPreview: () => void;
    validationCustomFieldError: boolean;
    validationGeneralFormError: boolean;
    options?: { label: string; value: string }[];
    selectedOption?: { label: string; value: string };
    setSelectedOption?: (option: { label: string; value: string }) => void;
    isNewFormFieldOpen?: boolean;
}


export const RegistrationFormHeader = mobxReact.observer(((props: RegistrationFormHeaderProps) => {
    const {
        openRegistrationFormPreview,
        validationCustomFieldError = false,
        validationGeneralFormError = false,
        options = [],
        selectedOption,
        setSelectedOption,
        isNewFormFieldOpen
    } = props;
    const [isStatusModalOpen, setStatusModalOpen] = useState(false);
    const statusButtonRef = useRef(null);

    const openStatusModal = (): void => {
        if (isNewFormFieldOpen) return;
        setStatusModalOpen(true);
    };

    const getErrorMessage = () => {
        if (validationCustomFieldError || validationGeneralFormError) {
            return <FormattedMessage
                id='oe.website.correctFormValidation'
                description='Validation message'
                defaultMessage='Please check all required fields.'
            />;
        }
        return null;
    };

    return (
        <div className='oe-popup-layout__header website-custom-field' >
            <div className='website-custom-field-header'>
                {!!options.length && !!selectedOption && !!setSelectedOption &&
                <div className='website-custom-field-header__item'>
                    <div
                        className={classnames('website-custom-field-header__dropdown')}
                        ref={statusButtonRef}
                    >
                        <div className='website-custom-field-header__wrapper' onClick={openStatusModal}>
                            <div className='website-custom-field-header__team'>
                                <Text
                                    message={selectedOption.label}
                                    withEllipsis
                                />
                                <ChevronSVG />
                            </div>
                        </div>
                        <Popover
                            padding={0}
                            isOpen={isStatusModalOpen}
                            buttonRef={statusButtonRef}
                            onClickOutside={() => setStatusModalOpen(false)}
                            customWidth={300}
                            position='bottom'
                            align='start'
                        >
                            <div className='website-custom-field-header__options'>
                                {options.map((option, index) =>
                                    <div
                                        className={classnames('website-custom-field-header__option', {
                                            'website-custom-field-header__option--selected': selectedOption.value === option.value
                                        })}
                                        key={option.value}
                                        onClick={() => {
                                            setSelectedOption(option);
                                            setStatusModalOpen(false);
                                        }}
                                    >
                                        <Text
                                            id={index.toString()}
                                            message={option.label}
                                            withEllipsis
                                        />
                                    </div>
                                )}
                            </div>
                        </Popover>

                    </div>
                </div>
                }
                <div className='website-custom-field-header__item'>
                    <div className={'preview'} onClick={() => openRegistrationFormPreview()}>
                        <OpenIcon/>
                        <Text className={'preview-text'} message='Preview'/>
                    </div>
                </div>
            </div>
            <div className='oe-form-field__error website-custom-field-header__error'>
                {getErrorMessage()}
            </div>
        </div>
    );
}));
